// Minicart
const defaults = {
    cartCounter: '.couter-minicart',
    cartDrawer: '.drawer',
    cartDrawerContent: '.cart-items' 

};

const cartCounter = document.querySelector(defaults.cartCounter);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);

$('form[action="/cart/add"]').on('submit', function(event) {
    event.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: addToCartOk,
        error: addToCartFail,
    });
});

function fetchCart(product = null) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart, product);

            if (cart.item_count === 0) {
                document.querySelector('.drawer__footer').classList.add('hidden');

                cartDrawerContent.innerHTML = `
                <div class="ajax-empty">
                    <div class='notify-minicart'>
                        <h2> Your cart is empty </h2>
                        <a href="/collections/all" class="button button--primary"> Continue shopping </a>
                    </div>

                    <p class="cart__login-title h3">Have an account?</p>
                    <p class="cart__login-paragraph">
                      <a href="/account/login" class="link underlined-link">Log in</a> to check out faster.
                    </p>
                </div>
                `;
            } else {
                     document.querySelector('.drawer__footer').classList.remove('hidden');
                renderCart(cart);
            }

        },
    });
}

function changeItem(line, quantity = 0, callback) {
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function (cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}

function onCartUpdate(cart, product = null) {
    const arrId = [];
    const arrProperties = [];
    const productJson = JSON.stringify(product);
    const arrPrd = JSON.parse(productJson);
    cart.items.forEach(function(item, index) {
        arrId.push(item.id);
        const propertiesItem = item.properties;
        if (propertiesItem && Object.keys(propertiesItem).length === 1 && Object.getPrototypeOf(propertiesItem) === Object.prototype) {
            arrProperties.push(JSON.stringify(item.properties));
        }
    });

}

function addToCartOk(product) {
    openCartDrawer();
    fetchCart(product);
}

function openCartDrawer() {
    cartDrawer.classList.add('active');
}


// function removeProductFromCart() {
//     console.log("remove product in line")
//     cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
// }

function addToCartFail() {
    // console.log("Add to cart fail")
}

function renderCart(cart) {
    // Output the cart title with total items
        cartCounter.innerHTML = `${cart.item_count}`;

    // Update total header counter minicart
    const counterMinicart = document.querySelector('.cart-count-bubble span');
    counterMinicart.innerHTML = `${cart.item_count}`;

    // Add data sub-total & total in minicart
    const subMiniCart = document.querySelector('.sub__total-value');
    subMiniCart.innerText = `$` + `${parseFloat(cart.original_total_price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`

    const totalMiniCart = document.querySelector('.totals__total-value');
    totalMiniCart.innerText = `$` + `${parseFloat(cart.original_total_price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`


    clearCartDrawer();

    if (cart.items.length > 0) {
        cart.items.forEach(function(item, index) {

            const productTitle = item.product_title;
            let imgPrd = item.image;
            if (item.image == null) {
                imgPrd = '//cdn.shopify.com/s/files/1/0562/7648/4141/t/22/assets/placeholder-images-image_large.png?v=14594405247086941604';
            }

            const productImage = '<img class="ajax-cart-item__image" src="' + imgPrd + '" >';
            const productPrice = '<div class="ajax-cart-item__price">' + '$' + parseFloat(item.line_price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'); + '</div>';
            // const productQuantity = '<div class="ajax-cart-item__quantity item__quantity item__line-key">' + item.quantity + '</div>';

            const productQuantity = `
                    <input type="hidden" class="item__line-key" value="${item.key}">
                    <input type="text" class="item__quantity" min="1" value="${item.quantity}">
            `;

                // $(".product-grid-item__type select").change(function () {
                //     $("select option:selected").each(function () {
                //         console.log("Variant selected add!:", this.value);
                //         // $('product-option').innerHTML(this.value)
                //     })

                // })

            const concatProductInfo = '<tr data-id="' + item.id + '" class="cart-item minicart-ajax">' +
                '<td class="cart-item__media" style="width: 72px; height: 72px;">' + productImage + '</td>' +
                '<td class="cart-item__details">' + '<a class="cart-item__name h4 break">' + productTitle + '</a>' +
                '<dl>' + '<div class="product-option">' + '<dt>Colour:</dt>' +
                '<dd>' + item.variant_title + '</dd>' + '</div>' + '</dl>' +
                '</td>' +
                '<td class="cart-item__totals right">' + '<div class="cart-item__price-wrapper">' +
                '<span class="price">' + productPrice + '</span>' + '</div>' + '</td>' +
                '<td class="cart-item__quantity">' + '<div class="quantity-popover-container">' +
                '<quantity-input class="quantity">' +
                '<button class="quantity__button minus">' + '-' + '</button>' +
                productQuantity +
                '<div class="quantity__button plus">' + '+' + '</div>' +
                '</quantity-input>' + '</div>' +
                '<div class="js-remove-item" data-line-key="' + item.key + '">' + 'x' + '</div>' +
                '</td>' +
                '</tr>';

            cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;


        });
    } else {
        document.querySelector('.drawer__footer').classList.add('hidden');

        cartDrawerContent.innerHTML = `
            <div class="ajax-empty">
                <div class='notify-minicart'>
                            <h2> Your cart is empty </h2>
                        <a href="/collections/all" class="button button--primary"> Continue shopping </a>
                </div>

                <p class="cart__login-title h3">Have an account?</p>
                <p class="cart__login-paragraph">
                    <a href="/account/login" class="link underlined-link">Log in</a> to check out faster.
                </p>
            </div>
        `

    }
    // Call the handleQuantityInputs which gets the quantity inputs and attaches events
    handleQuantityInputs();

    // Call the handleRemoveItem which gets the item__remove elements and attaches events
    handleRemoveItem();

    // Handle select variant
    // handleVariant();


}

function handleQuantityInputs() {
    // Get a refernce to any quantity inputs
    const qtyInputEls = document.querySelectorAll('.minicart-ajax .cart-item__quantity');


    // If there are any then loop through them and attach event listeners
    if (qtyInputEls.length > 0) {
        qtyInputEls.forEach(input => {
            // Get references to the plus and minus buttons
            let plusBtn = input.querySelector('.plus');
            let minusBtn = input.querySelector('.minus');
            // Get the quantity value
            let quantity = input.querySelector('.item__quantity').value;
            // Get the line item's key
            let lineKey = input.querySelector('.item__line-key').value;

            // Increase the quantity input value
            plusBtn.addEventListener('click', () => {
                // Increase the quantity value
                quantity++;
                // Calls the updateItemQuantity function which sends an Ajax request to update the items cart quantity
                updateItemQuantity(lineKey, quantity);
                // console.log("Plus item")
            });

            // Decrease the quantity input value, making sure it doesn't go below 1
            minusBtn.addEventListener('click', () => {
                // Decrease the quantity value
                quantity--;
                // Calls the updateItemQuantity function which sends an Ajax request to update the items cart quantity
                updateItemQuantity(lineKey, quantity);
            });
        });
    }
}

function handleRemoveItem(lineKey, value) {
    const removeItemButton = document.querySelectorAll('.js-remove-item');
    // console.log("remove item in cart")

    removeItemButton.forEach(button => {
        // Get the line item key from the buttons data attribute
        let lineKey = button.dataset.lineKey;

        button.addEventListener('click', () => {
            // Update the item quantity to 0 in the cart to remove it
            updateItemQuantity(lineKey, 0);
        });
    });
}

function updateItemQuantity(lineKey, value) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'id': lineKey,
                'quantity': parseInt(value)
            })
        })
        .then(response => response.json())
        .then(data => {
            renderCart(data);
        });
}

function clearCartDrawer() {
    
    cartDrawerContent.innerHTML = '';
}

document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});
